import { useEffect, useState } from 'react';

import { subscribeStaleClient } from './stale-client.ts';

/** 自动刷新已经用过一次后的兜底提示，避免把 Zod 原始报错直接暴露给业务用户。 */
export function StaleClientBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => subscribeStaleClient(() => setVisible(true)), []);

  if (!visible) return null;

  return (
    <div className="stale-client-banner" role="alert">
      <span>系统刚刚更新，当前页面仍是旧版本。</span>
      <button type="button" onClick={() => window.location.reload()}>刷新页面</button>
    </div>
  );
}
